<script>
import DocumentReviewAgentReportButton from '@/V2/documents/document-view/document-review-agent/DocumentReviewAgentReportButton.vue';
import {
  iAccordion,
  iAccordionItem,
  iAccordionItemSizes,
  iIcon,
  iTooltip,
  iTooltipAlignmentMode,
  iSpinner,
} from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'DocumentReviewAgent',
  components: {
    DocumentReviewAgentReportButton,
    iAccordion,
    iAccordionItem,
    iIcon,
    iTooltip,
    iSpinner,
  },
  data() {
    return {
      iAccordionItemSizes,
      iTooltipAlignmentMode,
      palette,
    };
  },
  computed: {
    ...mapGetters(['getDocumentReviewAgentRunsForDocId']),
    runs() {
      return this.getDocumentReviewAgentRunsForDocId(
        this.$route.params.document_id,
      );
    },
  },
  async mounted() {
    // Refetch run data on every mount to make sure we have the latest value.
    // If there's already a cached value in the store, it will be visible while
    // the new data loads in background.
    await this.fetchDocumentReviewAgentRunsForDocId(
      this.$route.params.document_id,
    );
  },
  methods: {
    ...mapActions(['fetchDocumentReviewAgentRunsForDocId']),
    onShowDocumentReviewAgentReport() {
      this.$emit('show-document-review-agent-report');
    },
  },
};
</script>

<template>
  <i-accordion>
    <!-- Document Review Agent -->
    <i-accordion-item
      :mount-open="true"
      title="Document Review Agent"
      :no-background="true"
      :size="iAccordionItemSizes.LARGE"
    >
      <!--title extra content-->
      <div
        slot="extra-title-content"
        class="extra-title-content d-flex flex-row align-items-center i-gap-4"
      >
        <!-- info icon -->
        <i-icon
          symbol="small-question-mark"
          :size="12"
          :colour="palette['light-neutral-80']"
          class="document-review-agent-help-icon"
          :stroke-width="1.5"
        ></i-icon>
        <i-tooltip
          :target="`.document-review-agent-help-icon`"
          title="Document Review Agent"
          description="The AI-powered Document Review Agent verifies authenticity by cross-checking document data with external sources."
          :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
        />
      </div>
      <document-review-agent-report-button
        v-if="runs?.length > 0"
        @show-document-review-agent-report="onShowDocumentReviewAgentReport"
      ></document-review-agent-report-button>
      <p
        v-else-if="runs?.length === 0"
        class="i-pb-10 i-text-body-3 i-text-neutral-110"
      >
        The agent has not run on this document yet
      </p>
      <i-spinner v-else size="md" class="loading i-pb-10"></i-spinner>
    </i-accordion-item>
  </i-accordion>
</template>

<style lang="scss" scoped>
.loading {
  height: 92px;
}
</style>
